import { X } from '@bg-shared/constants/textSymbols';

export const formatRouletteMultiplier = (multiplier: number): string => {
    if (typeof multiplier === 'number') {
        if (multiplier === 0) {
            return String(multiplier);
        }

        const num = multiplier % 1000 === 0 ? `${multiplier / 1000}K` : multiplier;
        return `${X}${num}`;
    }

    return '';
};
